var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasHeader)?_c('i-header',{attrs:{"type":_vm.category}}):_vm._e(),_c('router-view',{staticClass:"container"}),(_vm.hasFooter)?_c('i-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }